import React, { PureComponent } from 'react';
import { classes } from './Divider.st.css';
import { DividerProps } from './Divider.types';

class Divider extends PureComponent<DividerProps> {
  static displayName = 'Divider';

  render() {
    return <div className={classes.root} />;
  }
}

export default Divider;
